<template>
  <div>
    <div class="common-form">
      <span>{{ curItem.name }}</span>
    </div>
    <el-form size="small" :model="curItem" label-width="100px">

      <!--组件样式-->
      <div class="p-10-0 mb16 f14 border-b"><span class="gray6">组件样式</span></div>

      <!-- 背景颜色 -->
      <el-form-item label="背景颜色：">
        <div class="d-s-c">
          <el-color-picker v-model="curItem.style.background"></el-color-picker>
          <el-button type="button" style="margin-left: 10px;"
                     @click.stop="$parent.onEditorResetColor(curItem.style, 'background', '#ffffff')">重置
          </el-button>
        </div>
      </el-form-item>
      <el-form-item label="商品分类：">
        <el-cascader
          class="ww100" style="width: 50%"
          v-model="currCategory"
          v-if="CategoryList.length > 0"
          ref="cascader1"
          clearable
          :options="CategoryList"
          :props="{ checkStrictly: true, children: 'children', value: 'categoryId', label: 'name' }"
          @change="changeCategory"
        ></el-cascader>
        <el-button type="button" style="margin-left: 10px;"
                   @click.stop="resetCategory">重置
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import ProductApi from '@/api/product.js'
import draggable from 'vuedraggable'

export default {
  components: {
    draggable
  },
  data () {
    return {
      /*是否正在加载*/
      loading: true,
      /*商品类别*/
      CategoryList: [],
      /*当前选中的*/
      currCategory: [],
    }
  },
  props: ['curItem', 'selectedIndex', 'opts'],
  created () {
    /*获取列表*/
    this.getData()
    // this.currCategory = this.currCategoryAuto(this.CategoryList)
  },

  methods: {
    /*获取商品*/
    getData () {
      let self = this
      ProductApi.catList({}, true)
        .then(res => {
          self.CategoryList = res.data
          self.currCategory = self.currCategoryAuto(res.data)
          self.loading = false
        })
        .catch(error => {
          self.loading = false
        })
    },

    /*选择默认*/
    currCategoryAuto (list) {
      let arr = this.getArrList(list)
      return arr.reverse()
    },
    getArrList (list) {
      let arr = []
      for (let i = 0; i < list.length; i++) {
        let item = list[i]
        if (item.categoryId === this.curItem.params.auto.category) {
          arr.push(item.categoryId)
          break
        } else {
          if (Object.prototype.toString.call(item.children) === '[object Array]' && item.children.length > 0) {
            arr = this.getArrList(item.children)
            if (arr && arr.length) {
              arr.push(item.categoryId)
              break
            }
          }
        }
      }
      return arr
    },
    /*检查*/
    check (checked, name) {
      let value = checked ? 1 : 0
      this.curItem.style.show[name] = value
    },

    /*选择类别*/
    changeCategory (e) {
      let item = this.$refs['cascader1'].getCheckedNodes()
      if (item && item.length) {
        this.curItem.params.auto.category = item[0].data.categoryId
      } else {
        this.curItem.params.auto.category = 0
      }
    },
    resetCategory () {
      this.currCategory = []
      this.curItem.params.auto.category = 0
    }
  }
}
</script>

<style>
.choice-product-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.choice-product-list .item {
  position: relative;
  width: 80px;
  height: 80px;
  margin-right: 10px;
  margin-bottom: 10px;
  border: 1px solid #dddddd;
}

.choice-product-list .item .delete-box {
  position: absolute;
  width: 20px;
  height: 20px;
  top: -10px;
  right: -10px;
  font-size: 20px;
  cursor: pointer;
  color: #999999;
}

.choice-product-list .item .delete-box:hover {
  color: rgb(255, 51, 0);
}

.choice-product-list .item.plus-btn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.choice-product-list .item.plus-btn > i {
  font-size: 30px;
  color: #cccccc;
}

.choice-product-list img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/params/productSort.vue